<template>
  <b-modal
    size="xl"
    button-size="sm"
    hide-footer
    :title="prefix + title"
    @hidden="cancelar"
    @close="cancelar"
    v-model="showModal"
  >
    <subgrupo-produto-list
      @close="cancelar"
      :prefix="prefix"
      :title="title"
      :currentGrupo="currentGrupo"
    ></subgrupo-produto-list>
  </b-modal>
</template>
<script>
export default {
  name: "ModalSubgrupoListNovo",
  components: {
    SubgrupoProdutoList: () =>
      import("@/modules/cadastros/grupo-produto/SubgrupoProdutoList.vue"),
  },

  props: {
    currentGrupo: Object,
    prefix: {
      type: String,
    },
    title: {
      type: String,
      default: " > Subgrupo do Produto",
    },
  },

  data() {
    return {
      showModal: true,
    }
  },

  methods: {
    async cancelar() {
      this.$emit("close")
    },
  },
}
</script>
